import {FC} from 'react'
import {Content} from '@prismicio/client'
import {SliceComponentProps} from '@prismicio/react'
import {Context} from 'src/common/types'
import {ProductOverviewDefaultVariation} from './DefaultVariation'
import {ProductOverviewHighlightsVariation} from './HighlightsVariation'

/**
 * Props for `ProductOverview`.
 */
export type ProductOverviewProps = SliceComponentProps<Content.ProductOverviewSlice> & {context: Context}

/**
 * Component for "ProductOverview" Slices.
 */
const ProductOverview: FC<ProductOverviewProps> = ({slice, context, index: componentIndex}) => {
  switch (slice.variation) {
    case 'highlights':
      return <ProductOverviewHighlightsVariation slice={slice} />
    case 'default':
      return <ProductOverviewDefaultVariation slice={slice} context={context} componentIndex={componentIndex} />
    default:
      return null
  }
}

export default ProductOverview
